import { render, staticRenderFns } from "./OptionalArticleComponent.vue?vue&type=template&id=51abe189&"
import script from "./OptionalArticleComponent.vue?vue&type=script&lang=js&"
export * from "./OptionalArticleComponent.vue?vue&type=script&lang=js&"
import style0 from "./OptionalArticleComponent.vue?vue&type=style&index=0&id=51abe189&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports